import { getViemClients, } from "@bracket/contractor-next";
import { getContractWithABI, } from "@bracket/chainography";
import type { EthereumAddress, } from "@bracket/types";
import { wagmiConfig as config, } from "@wagmiconfig";
import type { BlockHash, } from "@bracket/chainography";


export declare type AssertAllowanceProps = {
	spender: EthereumAddress;
	token: EthereumAddress;
	amount: bigint;
}


export const assertAllowance = async ({
	spender,
	token,
	amount,
}: AssertAllowanceProps) => {
	const allowed = await allowance({ spender, token, });
	if(allowed < amount) {
		await approve({ spender, token, amount, });
	}
	return true;
}






export declare type ApproveProps = {
	spender: EthereumAddress;
	token: EthereumAddress;
	amount: bigint;
}

export const approve = async ({
	spender,
	token,
	amount,
}: ApproveProps): Promise<BlockHash> => {
	const [ reader, writer, ] = await getViemClients({ config, });
	const [ _, abi ] = getContractWithABI("ERC20", 1);
	const { request, } = await reader.simulateContract({
		address: token,
		abi,
		functionName: "approve",
		args: [
			spender,
			amount,
		],
		account: writer.account,
	});
	const hash = await writer.writeContract(request);
	await reader.waitForTransactionReceipt({ hash, });
	return hash;
}






export declare type AllowanceProps = {
	spender: EthereumAddress;
	token: EthereumAddress;
}

export const allowance = async({
	spender,
	token,
}: AllowanceProps): Promise<bigint> => {
	const [ reader, ] = await getViemClients({ config, });
	const [ _, abi ] = getContractWithABI("ERC20", 1);
	const result: bigint = await reader.readContract({
		address: token,
		abi,
		functionName: "allowance",
		args: [
			spender,
			token,
		],
	});
	return result;
}
